export const API_URLS = {
  login: "api/login/",
  verifyOTP: "api/verify-login-otp/",
  banners: "api/updated-api-banner-list/",
  categories: "api/overall-main-category-sub-category-list/",
  recentlyAdded: "api/show-recently-added-variants-data/",
  recommandedProducts: "api/get-recommanded-products-data/",
  topRatedProducts: "api/show-top-rated-variants-data/",
  productList: "api/api-product-list-by-near-store/",
  mostViewedProducts: "api/show-mostviewed-product-variants-data/",
  frequentlyAskedQuestion: "api/show-frequently-asked-questions/",
  profile: "api/my-profile/",
  cartList: "api/cart-list/",
  addToCart: "api/add-to-cart/",
  addressList: "api/my-address-list/",
  addAddress: "api/add-new-address/",
  updateAddress: "api/update-address/",
  codCheckout: "api/order-checkout-cash-on-delivery/",
  cityList: "api/city-list/",
  stateList: "api/state-list/",
  countryList: "api/country-list/",
  myOrders: "api/my-order/",
  subCategories: "api/sub-category-list/",
  myWishList: "api/wishlist-list/",
  addToWishList: "api/add-to-wishlist/",
  removeWishList: "api/remove-from-wishlist/",
  checkOut: "api/order-checkout/",
  paymentReceipt: "api/create-payment-receipt/",
  todayDeals: "api/get-todays-deals-data/",
  myReviews: "api/show-rating-and-review-by-user/",
  myQuestions: "api/show-frequently_asked_questions_by_user/",
  searchProducts: "api/filter-product-list",
  allFilters: "api/all-filter-product-list",
  writeReviw: "api/write-review/",
  removeCart: "api/remove-from-cart/",
  increaseCart: "api/increase-product-quantity-from-cart/",
  decreaseCart: "api/decrease-product-quantity-from-cart/",
  checkPincode: "api/order-delivery-time-by-city/",
  downVoteFaq: "api/downvote-question-counter/",
  upVoteFaq: "api/upvote-question-counter/",
  myWallet: "api/my-wallet/",
  bulkAddToCart: "api/bulk-add-to-cart/",
  cityBasedWarehouse: "api/multivendor-city-based-warehouse-store-list/",
  invoiceDetail: "api/amaka-get-single-invoice-details/",
  invoiceList: "api/amaka-get-all-order-data/",
  createInvoice: "api/amaka-create-invoice/",
  invoicePerItem: "api/amaka-get-single-order-item-invoice-details/",
  resonsForCancellation: "api/reason-for-cancellation-list/",
  accountDelation: "api/multivendor-customer-deactivate/",
  returnResons: "api/reason-for-return-list/",
  return: "api/order-return-section/",
  returnReplacement: "api/reason-for-replacement-list/",
  replacement: "api/order-replacement-section/",
  location: "api/save-address-for-filter-product/",
  homepagedata: "api/product-show-on-website-categorie-wise-api/",
  notify_me: "api/customer-notify-me-data/",
};
